// extracted by mini-css-extract-plugin
module.exports = {"table":"AllUsersReportTable_table__DSWUV"};